import { GdwcIconButton } from './gdwc-icon-button/gdwc-icon-button.js';

if (!customElements.get('gdwc-icon-button')) {
  customElements.define('gdwc-icon-button', GdwcIconButton);
}
